module.exports = __webpack_public_path__ + "media/images/icons/livestream-58937d29654e006d469bd851a3e32410.svg";